var _path, _path2, _path3, _path4, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscountXx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 58,
    viewBox: "0 0 51 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17238 47.332C6.67972 48.1827 7.48887 48.8112 8.43871 49.0922L13.0289 50.4503L18.4326 52.0166C19.4816 52.3207 20.6097 52.1758 21.5478 51.6164L46.7963 36.5596C48.6654 35.445 49.277 33.0263 48.1624 31.1573L40.1086 17.6519C38.994 15.7829 36.5753 15.1713 34.7063 16.2859L9.38886 31.3837C8.49132 31.919 7.84317 32.7888 7.58699 33.802L5.16335 43.3867C4.90716 44.3999 5.06394 45.4733 5.59918 46.3708L6.17238 47.332ZM11.3917 43.5154C10.987 42.8368 10.1089 42.6148 9.43026 43.0194C8.75166 43.4241 8.5296 44.3023 8.93428 44.9809C9.33896 45.6595 10.2171 45.8815 10.8957 45.4769C11.5743 45.0722 11.7964 44.194 11.3917 43.5154Z",
    stroke: "#FC916B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3008 34.0593C25.0737 33.5984 25.3426 32.6251 24.9015 31.8853C24.4603 31.1455 23.4761 30.9194 22.7032 31.3803C21.9303 31.8412 21.6614 32.8146 22.1025 33.5544C22.5437 34.2942 23.5279 34.5203 24.3008 34.0593Z",
    stroke: "#FC916B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9248 37.1394C32.6977 36.6785 32.9667 35.7051 32.5255 34.9653C32.0843 34.2255 31.1001 33.9994 30.3272 34.4604C29.5543 34.9213 29.2854 35.8946 29.7266 36.6345C30.1677 37.3743 31.1519 37.6003 31.9248 37.1394Z",
    stroke: "#FC916B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7692 28.6661L25.6072 40.1226",
    stroke: "#FC916B",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3278_6692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.11328 21.3672C2.11328 21.3672 6.98867 23.1319 8.11566 23.9235",
    stroke: "#FC916B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69141 4.62695C8.78967 6.68333 10.0565 8.64512 11.479 10.4922C12.5015 11.791 15.7674 16.973 15.7674 16.973",
    stroke: "#FC916B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2866 5.16211C26.2866 5.16211 25.3652 10.8106 25.4106 11.0097",
    stroke: "#FC916B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3278_6692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7919,
    height: 23.5911,
    fill: "white",
    transform: "translate(6.21729) rotate(12.6053)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountXx);
export default __webpack_public_path__ + "static/media/discount-xx.81b3676bcee3e4ebbc76d6091ccce820.svg";
export { ForwardRef as ReactComponent };